import { AfterViewInit, Component, ElementRef, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { EventEmitter } from 'events';

import { Utenteservice } from '../../services/utente.service';
import { NicaMainMenuComponent } from '../nica-main-menu/nica-main-menu.component';


class ItemMenu {
  active: string;
  icon: string;
  id: number;
  image: string;
  items: []
  text: string;
  visible: boolean;

}

@Component({
  selector: 'app-nica-side-menu',
  templateUrl: './nica-side-menu.component.html',
  styleUrls: ['./nica-side-menu.component.css'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class NicaSideMenuComponent implements OnInit, AfterViewInit {

  @ViewChild('mainmenu', { static: false }) mainmenu: NicaMainMenuComponent

  @ViewChildren('childWrap') childWrap: ElementRef;

  @Input() menuType



  position: string;
  backgroud: string;
  Items: [];
  Preferiti: [];
  titleMenu: string;
  initClass: string;
  childWidth: string;
  thisShow: boolean;
  ItemActive: ItemMenu;
  menuWidth: string
  coordinatesTop: string

  constructor(public utenteService: Utenteservice, private _eref: ElementRef) {


  }

  onClick(event) {



    let targetClass = event.target.className;

    


    let includes = targetClass.indexOf('del-pref') !== -1
    let includes2 = targetClass.indexOf('add-pref') !== -1

    let refClass = targetClass.indexOf('button-menu-mobile') !== -1

    let refClass2 = targetClass.indexOf('icon-icona-header') !== -1

    let refClass3 = targetClass.indexOf('nav-icon') !== -1

    if (refClass3 || refClass || refClass2) {
      
    }

    //Ho doovuto fare pezzotto perchè: se cliccavo sul bottone rimuovi dai preferiti si chiudeva sto cesso di menu
    if (!this._eref.nativeElement.contains(event.target) && !includes && !includes2) {

      //console.log(this._eref.nativeElement.contains(event.target))
      //this.reset(this.ItemActive)
    }


  }


  reset(ev) {
    let item = []
    item['itemData'] = this.ItemActive

    this.selected(item)


    //document.getElementsByClassName('content')[0].classList.remove('content-margin-left');
    // document.getElementById('navigation-end').classList.remove('topbar-nav-right-mobile');
    //document.getElementById('menu-end-show').style.display = 'hide'
  }

  selected(ev: any) {
   
    if (this.ItemActive != undefined) {
      if (ev.itemData == undefined) {
        return
      }
      const idItemSel = ev.itemData['id'];
      const idItemActive = this.ItemActive.id

      if (idItemActive == idItemSel && this.thisShow) {
        this.thisShow = false;
        ev.active = false;
        ev.itemData['active']=false
        this.ItemActive = new ItemMenu

       // console.log('selected-->',idItemActive + '=='  +idItemSel + '&&' + this.thisShow);
       // console.log('this.mainmenu-->',ev);

        if (this.menuType == 'type1' ){
          setTimeout(() => {
            document.body.classList.add('enlarge-menu')
            document.body.classList.add('enlarge-menu-all')

          }, 150);
        }
         
        if (this.menuType == 'type2' ){
          setTimeout(() => {
            document.body.classList.add('enlarge-menu')
            document.body.classList.add('enlarge-menu-all')
            this.mainmenu.showSubItems=[]
          }, 150);
        }
        

        return
      }

    }




    if (typeof (ev) != 'undefined') {
      if(typeof ev.itemData != 'undefined'){
        ev.itemData.active = true;
        //console.log('selected-->',ev );
      this.Items = [];
      this.Preferiti = [];
      if (ev.itemData.items != undefined)
        if (ev.itemData.items.length > 0) {

          if (this.menuType == 'type1') {
            setTimeout(() => {
              this.Items = ev.itemData.items;
              this.thisShow = true;
              this.ItemActive = ev.itemData
              this.titleMenu = ev.itemData.text;
            },150);





            document.body.classList.remove('enlarge-menu');
            document.body.classList.remove('enlarge-menu-all');

          }else if (this.menuType == 'type2'){

            this.thisShow = true;
            this.Items = ev.itemData.items;
            this.ItemActive = ev.itemData;
           
          }




          // document.getElementById('navigation-end').classList.add('topbar-nav-right-mobile');
          //document.getElementById('menu-end-show').style.display = 'block'

        } else {
          this.thisShow = false;
          this.ItemActive = new ItemMenu
          document.body.classList.add('enlarge-menu-all');
          document.body.classList.add('enlarge-menu');

        }
      }
      
    }





  }


  initializeMenu() {

    this.position = 'vertical';
    this.backgroud = '#c0c0c0';



    this.initClass = this.menuType != 'type2' ? 'absolute' : 'relative';
    this.menuWidth = this.menuType != 'type2' ? '240px' : ''

  }

  ngOnInit() {

    this.initializeMenu();

  }


  clickOutside() {
    this.thisShow = false;
  }
  ngAfterViewInit() {


  }

  clickChangeMenu(ev) {

    this.menuType = 'type1'


  }

  closeMenu(event) {
    event.preventDefault();
    event.stopPropagation()


    /*setTimeout(() => {

      this.reset(event)
    }, 180000);*/

  }
}


